<div
  class="smart-fix-layout"
  [class.voice-chat-active]="interactionModeSelected === 'Voice to Voice' && uiState === SmartFixUIState.Chat"
>
  <div class="smart-fix-content">
    <section
      class="back-button"
      [class.hidden]="interactionModeSelected === 'Voice to Voice' && uiState === SmartFixUIState.Chat"
    >
      <i [class]="titleAndButtonsState.backIconClass"></i>
      @if (titleAndButtonsState.link === '#feedback') {
        <a (click)="moveToFeedback(); $event.preventDefault()" href="#">
          {{ titleAndButtonsState.buttonTitle }}
        </a>
      } @else {
        <a [href]="titleAndButtonsState.link"> {{ titleAndButtonsState.buttonTitle }} </a>
      }
    </section>

    @if (uiState === SmartFixUIState.Idle) {
      <h2 class="heading-1">
        {{ titleAndButtonsState.title }}
      </h2>

      <app-smart-fix-image-hero
        #mobileHero
        [uiState]="uiState"
        [isOnMobile]="userIsOnMobile"
        [staticHeroOnly]="showInteractionModeDialog"
        (transitionComplete)="onTransitionComplete()"
        class="mobile-only"
      ></app-smart-fix-image-hero>
    }

    @if (uiState === SmartFixUIState.Chat) {
      <app-smart-fix-chat
        [sessionId]="vm.sessionId"
        [chatSession]="chatSession"
        [chatHistory]="vm.chatHistory"
        [planNumber]="this.planNumber"
        (addMessage)="onAddMessage($event)"
        (sessionIdChanged)="onSessionIdChanged($event)"
        [chatLoading]="vm.chatLoading"
        [title]="titleAndButtonsState.title"
        [interactionMode]="interactionModeSelected"
        (interactionModeChanged)="onInteractionModeChanged($event)"
        (goToRepairBooking)="moveToFeedback()"
        [gatheringContextActive]="gatheringContextActive"
        [solutionSelected]="solutionSelected"
        (contextGatheringDone)="onContextGatheringStepDone()"
        [showGreeting]="showGreeting"
        [showSafetyCheckInput]="showSafetyCheck"
        (safetyCheckCompleted)="onSafetyCheckCompleted()"
        (recordFireSafetyCheck)="onRecordFireSafetyCheck()"
        [agenticSolutionActiveFlag]="shouldUseAgenticSolution"
        [claimBundleData]="vm.bundle"
        [V2VisLoading]="waitingForFirstNovaSonicResponse"
        @slideInOut
      ></app-smart-fix-chat>

      @if (isSwitchingFromVoiceToText && interactionModeSelected === 'Voice to Voice') {
        <div class="voice-to-text-loader-overlay">
          <div class="voice-to-text-loader-modal">
            <app-loading-spinner [size]="56" [strokeWidth]="2"></app-loading-spinner>
            <h4>Switching to text chat</h4>
            <p class="body">This may take a few moments...</p>
          </div>
        </div>
      }
    }

    @if (uiState === SmartFixUIState.Idle) {
      <div class="disclaimers">
        @for (incentive of incentives; track incentive.icon) {
          <section class="incentive">
            <div class="icon-gradient-wrapper">
              <div class="icon-wrapper">
                <i [class]="'fa-light fa-' + incentive.icon + ' '"></i>
              </div>
            </div>

            <div class="description-wrapper">
              <p class="body">
                {{ incentive.description }}
              </p>
            </div>
          </section>
        }

        @for (hint of hints; track hint) {
          <p class="hint">{{ hint }}</p>
        }

        @if (showSolutionToggle) {
          <smart-fix-solution-toggle
            data-testid="solution-toggle"
            (modeSelected)="onModeSelected($event)"
          ></smart-fix-solution-toggle>
        }
      </div>

      <section class="actions flex-col">
        <app-button
          [buttonOptions]="{
            disabled: vm.isLoading,
          }"
          dataLabel="try-smart-fix"
          class="min-w-160"
          (onClick)="onTrySmartFix()"
        >
          @if (transitionPlaying) {
            <app-loading-spinner variant="white" [size]="20"></app-loading-spinner>
          } @else {
            <i class="fa-light fa-sparkles" style="color: #ffffff"></i>
            Try Smart-fix
          }
        </app-button>
        <app-button
          dataLabel="continue-button"
          [buttonOptions]="{
            variant: 'secondary',
            disabled: vm.isLoading,
          }"
          [loading]="vm.isLoading"
          class="min-w-160"
          (onClick)="continueToBookingForm()"
          [class.disabled]="transitionPlaying"
        >
          No, book an engineer
        </app-button>
      </section>
    }

    @if (uiState === SmartFixUIState.Feedback) {
      <app-smart-fix-feedback
        [client]="interactionModeSelected === 'Voice to Voice' ? voiceChatSession : chatSession"
        [title]="titleAndButtonsState.title"
        [mmrLink]="MMRlink"
        [solution]="interactionModeSelected === 'Voice to Voice' ? 'Voice to Voice' : solutionSelected || 'unknown'"
      ></app-smart-fix-feedback>
    }
  </div>

  <div
    class="smart-fix-image desktop-only"
    [class.hidden]="interactionModeSelected === 'Voice to Voice' && uiState === SmartFixUIState.Chat"
  >
    @if (interactionModeSelected !== 'Voice to Voice') {}
    <app-smart-fix-image-hero
      #desktopHero
      [uiState]="uiState"
      [isOnMobile]="userIsOnMobile"
      [staticHeroOnly]="showInteractionModeDialog"
      (transitionComplete)="onTransitionComplete()"
    ></app-smart-fix-image-hero>

    @if (uiState === SmartFixUIState.Chat) {
      <div class="book-an-engineer">
        @if (interactionModeSelected !== 'Voice to Voice') {
          <i [class]="endChatButtonState.backIconClass"></i>
          <a
            class="button-text"
            (click)="endChatButtonState.action()"
            (keydown.enter)="endChatButtonState.action()"
            tabindex="0"
            role="button"
            data-testid="end-chat-button"
            >{{ endChatButtonState.buttonTitle }}</a
          >
        }
      </div>
    }
  </div>
</div>
